<template>
  <div style="padding:14px 10px">
    <!-- 面包屑导航 -->
    <div class="cur_route">{{ $route.name }}</div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home/index' }">Dashboard</el-breadcrumb-item>
      <el-breadcrumb-item>{{ $route.name }}</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Search筛选 -->
    <el-form :inline="true" :model="params" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="params.name" placeholder="Cardholder name" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">Search</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" element-loading-text="Loading..."
      style="width: 922px;">
      <el-table-column prop="name" label="名称" width="100" align="center">
      </el-table-column>
      <el-table-column prop="lang" label="语言" width="100" align="center">
      </el-table-column>
      <el-table-column prop="lan" label="语言缩写" width="100" align="center">
      </el-table-column>
      <el-table-column prop="area_code" label="区号" width="100" align="center">
      </el-table-column>
      <el-table-column prop="currency" label="货币单位" width="100" align="center">
      </el-table-column>
      <el-table-column prop="time_difference" label="时差" width="100" align="center">
      </el-table-column>
      <el-table-column prop="state" label="状态" width="100" align="center">
        <template slot-scope="scope">
          <el-link type="success" :underline="false" v-if="scope.row.state == 1">显示</el-link>
          <el-link type="danger" :underline="false" v-if="scope.row.state == 2">隐藏</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="sort" label="排序，越大越靠前" width="120" align="center">
      </el-table-column>
      <el-table-column align="center" label="操作" width="100">
        <template slot-scope="scope">
          <el-button size="mini" type="warning" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- Edit界面 -->
    <el-dialog title="编辑" :visible.sync="editFormVisible" width="30%" @click='closeDialog("edit")'>
      <el-form label-width="120px" :model="editForm" ref="editForm" :rules="rules">
        <el-form-item label="状态" prop="state">
          <el-radio-group v-model="editForm.state">
            <el-radio :label="1">显示</el-radio>
            <el-radio :label="2">隐藏</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input size="small" type="number" v-model="editForm.sort" auto-complete="off" placeholder="设置排序" clearable>
          </el-input>
          <span style="color:red">（数字越大越靠前）</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog("edit")'>Cancel</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">Save
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  bdCountryList, bdCountrySave
} from '../../api/apiFun'
import {
  timestampToTime
} from '@/utils/util';
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制Edit页面显示与隐藏
      title: 'Add',
      editForm: {
        id: '',
        state: '',
        sort: '',
      },
      // rules 表单验证
      rules: {
        state: [{
          required: true,
          message: 'Please enter the state',
          trigger: 'blur'
        }],
        sort: [{
          required: true,
          message: 'Please enter the sort',
          trigger: 'blur'
        }],
      },
      params: {
        page: 1,
        limit: 20,
        name: ''
      },
      listData: [],
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 20
      }
    }
  },
  components: {
    Pagination
  },
  filters: {
    timestampToTime: function (timestamp) {
      return timestampToTime(timestamp)
    }
  },
  created() {
    this.getdata(this.params)
  },
  methods: {
    // Edit、增加页面Save方法
    submitForm(editData) {
      this.loading = true
      this.$refs[editData].validate(valid => {
        if (valid) {
          bdCountrySave(this.editForm).then(res => {
            this.editFormVisible = false
            this.loading = false
            if (res.code == 200) {
              this.getdata(this.params)
              this.$message({
                type: 'success',
                message: 'Cardholder save succeeded!'
              })
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          }).catch(err => {
            this.editFormVisible = false
            this.loading = false
            this.$message.error('Saving failed, please try again later!')
          })
        } else {
          this.loading = false
          return false
        }
      })
    },
    // 获取Cardholder list
    getdata(parameter) {
      this.loading = true
      bdCountryList(parameter).then(res => {
        this.loading = false
        if (res.code == 400) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          this.listData = res.datas.list
          // 分页赋值
          this.pageparm.currentPage = this.params.page
          this.pageparm.pageSize = this.params.limit
          this.pageparm.total = res.datas.count
        }
      }).catch(err => {
        this.loading = false
        this.$message.error('Failed to get cardholder list, please try again later!')
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.params.page = parm.currentPage
      this.params.limit = parm.pageSize
      this.getdata(this.params)
    },
    // Search事件
    search() {
      this.params.page = 1
      this.getdata(this.params)
    },
    //显示Edit界面
    handleEdit: function (index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = 'Edit'
        this.editForm.id = row.id
        this.editForm.state = row.state
        this.editForm.sort = row.sort
      } else {
        this.title = 'Add'
        this.editForm.id = ''
        this.editForm.state = 1
        this.editForm.sort = 0
      }
    },
    // closeEdit、增加弹出框
    closeDialog(dialog) {
      if (dialog == 'edit') {
        this.editFormVisible = false
      } else if (dialog == 'perm') { }
    },
  }
}

</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/country/country.vue